// extracted by mini-css-extract-plugin
var _1 = "active__rgPj_";
var _2 = "nav-item__Izqoc";
export { _1 as "active", _2 as "navItem" }
